import users from "../data/users";
import { combineReducers } from "redux";
import { getFilteredTasks } from "../Selectors/tasks";

const filtersReducerDefaultState = {
  taskName: "",
  taskStatus: "open",
};

const authReducerInitialState = {
  authenticated: false,
  email: "",
};

function taskReducer(state = {}, action) {
  switch (action.type) {
    case "ADD_TASK":
      if (!state[action.userid]) {
        return {
          ...state,
          // [action.userid]: [action.taskName, action.taskStatus],
          [action.userid]: {
            key: action.taskid,
            value: [
              {
                taskName: action.taskName,
                taskStatus: action.taskStatus,
                assignedBy: action.assignedBy,
                createdAt: action.createdAt,
              },
            ],
          },
        };
      } else {
        return {
          ...state[action.userid],
          [action.userid]: {
            key: [...state[action.userid].key, action.taskid],
            value: [
              ...state[action.userid].value,
              {
                taskName: action.taskName,
                taskStatus: action.taskStatus,
                assignedBy: action.assignedBy,
                createdAt: action.createdAt,
              },
            ],
          },
        };
      }
    case "LOAD_TASKS":
      return action.tasks;

    case "CLOSE_TASK":
      const indexOfClosedTask = state[action.userid].key.indexOf(action.taskid);
      state[action.userid].value[indexOfClosedTask] = "Closed";
      return state;
    case "REMOVE_TASK":
      const indexOfRemovedTask = state[action.userid].key.indexOf(
        action.taskid
      );
      state[action.userid].key.splice(indexOfRemovedTask, 1);
      state[action.userid].value.splice(indexOfRemovedTask, 1);
      return state;
    default:
      return state;
  }
}

function userReducer(state = users, action) {
  //remove photo
  switch (action.type) {
    case "REMOVE_USER":
      return [
        ...state.slice(0, action.index),
        ...state.slice(action.index + 1),
      ];
    case "ADD_USER":
      return [...state, action.user];
    case "LOAD_USERS":
      return action.users;
    default:
      return state;
  }
}

// Filter Reducers

const filtersReducer = (state = filtersReducerDefaultState, action) => {
  switch (action.type) {
    case "SET_NAME_FILTER":
      // console.log(action.taskName, "task name in reducer");
      return {
        ...state,
        taskName: action.taskName,
      };
    case "SET_STATUS_FILTER":
      return {
        ...state,
        taskStatus: action.taskStatus,
      };
    default:
      return state;
  }
};

const authReducer = (state = authReducerInitialState, action) => {
  switch (action.type) {
    case "SET_AUTH_STATUS":
      return {
        ...state,
        authenticated: action.authenticated,
        email: action.email,
      };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  tasks: taskReducer,
  users: userReducer,
  filters: filtersReducer,
  auth: authReducer,
});

export default rootReducer;
